import {
  Button,
  DatePicker,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@data-delivery/d3s';
import { format } from 'date-fns';
import { type UseFormReturn } from 'react-hook-form';
import { type AssignmentFormValues } from './form-schema';

interface FieldDateRangeProps {
  form: UseFormReturn<AssignmentFormValues>;
  pending?: boolean;
}

export function FieldDateRange({ form, pending }: FieldDateRangeProps) {
  return (
    <>
      <FormField
        control={form.control}
        name='startDate'
        render={({ field }) => (
          <FormItem className='flex flex-col'>
            <FormLabel>Start Date</FormLabel>
            <FormControl>
              <DatePicker
                value={field.value ? new Date(field.value) : undefined}
                onChange={d => {
                  field.onChange(d ? format(d, 'yyyy-MM-dd') : undefined);
                }}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name='endDate'
        render={({ field }) => (
          <FormItem className='flex flex-col'>
            <FormLabel>End Date</FormLabel>
            <FormControl>
              <div className='flex items-center gap-2'>
                <DatePicker
                  value={field.value ? new Date(field.value) : undefined}
                  onChange={d => {
                    field.onChange(d ? format(d, 'yyyy-MM-dd') : '');
                  }}
                />
                {field.value && (
                  <Button
                    type='button'
                    variant='outline'
                    size='sm'
                    onClick={() => {
                      field.onChange('');
                    }}
                    disabled={pending}
                  >
                    Clear
                  </Button>
                )}
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
